import { Radio } from "lucide-react";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      {/* Brand panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 bg-card border-r border-border overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.15]"
          style={{
            backgroundImage:
              "linear-gradient(hsl(var(--border)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--border)) 1px, transparent 1px)",
            backgroundSize: "44px 44px",
          }}
          aria-hidden="true"
        />
        <div className="relative flex items-center gap-3">
          <div className="grid place-items-center h-11 w-11 rounded-md bg-primary text-primary-foreground">
            <Radio className="h-6 w-6" aria-hidden="true" />
          </div>
          <div>
            <p className="font-display font-bold text-2xl tracking-tight">StreamCore</p>
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-1">IPTV Management Platform</p>
          </div>
        </div>
        <div className="relative space-y-6 max-w-md">
          <h2 className="font-display text-4xl font-bold tracking-tight leading-tight">
            Command your entire IPTV business from one console.
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            Multi-panel management, reseller credits, subscription automation and real-time analytics — engineered for scale.
          </p>
          <div className="flex flex-wrap gap-2 pt-2">
            {["Unlimited Xtream Panels", "Reseller System", "Live Analytics", "Auto Panel Failover"].map((t) => (
              <span key={t} className="text-xs px-3 py-1.5 rounded-full border border-border text-muted-foreground">
                {t}
              </span>
            ))}
          </div>
        </div>
        <p className="relative text-xs text-muted-foreground font-mono">© 2026 StreamCore. All systems operational.</p>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm animate-fade-up">
          <div className="lg:hidden flex items-center gap-2.5 mb-8">
            <div className="grid place-items-center h-9 w-9 rounded-md bg-primary text-primary-foreground">
              <Radio className="h-5 w-5" />
            </div>
            <p className="font-display font-bold text-xl tracking-tight">StreamCore</p>
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tight">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-2 text-sm">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-center text-muted-foreground">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
